import {
  utcIsoToParisDateAndTime,
  parisDateAndTimeToUtcIso,
  toTimeInputValue,
} from '@/components/admin/users/userStatusSchedule';

export const INACTIVE_REASON_VALUES = ['none', 'maintenance', 'update', 'end_of_service'];

export const INACTIVE_REASON_OPTIONS = [
  { value: 'none', label: 'Aucun' },
  { value: 'maintenance', label: 'Maintenance' },
  { value: 'update', label: 'Mise à jour' },
  { value: 'end_of_service', label: 'Fin de service / Retrait' },
];

export function normalizeInactiveReason(reason) {
  if (INACTIVE_REASON_VALUES.includes(reason)) return reason;
  return 'none';
}

export function getDefaultApplicationInactiveFormFields() {
  return {
    inactive_reason: 'none',
    inactive_expected_date: '',
    inactive_expected_time: '',
  };
}

/** Afficher motif + ETA : désactivé maintenant ou désactivation programmée confirmée */
export function isApplicationInactiveDetailsRelevant(fd) {
  if (fd?.is_active === false) return true;
  return (
    fd?.status_program_deactivation === true &&
    String(fd?.status_deactivation_date || '').trim() &&
    String(fd?.status_deactivation_time || '').trim()
  );
}

export function applyApplicationInactiveFromApi(entity) {
  const eta = utcIsoToParisDateAndTime(entity?.inactive_expected_available_at);
  return {
    inactive_reason: normalizeInactiveReason(entity?.inactive_reason),
    inactive_expected_date: eta.date,
    inactive_expected_time: eta.time,
  };
}

export function buildApplicationInactiveApiFields(fd) {
  if (!isApplicationInactiveDetailsRelevant(fd)) {
    return { inactive_reason: null, inactive_expected_available_at: null };
  }
  const reason = normalizeInactiveReason(fd.inactive_reason);
  const d = String(fd.inactive_expected_date || '').trim();
  const t = String(fd.inactive_expected_time || '').trim();
  const eta = d && t ? parisDateAndTimeToUtcIso(d, t) : null;
  return {
    inactive_reason: reason,
    inactive_expected_available_at: eta,
  };
}

export function getInactiveReasonLabel(reason) {
  const normalized = normalizeInactiveReason(reason);
  const opt = INACTIVE_REASON_OPTIONS.find((o) => o.value === normalized);
  return opt?.label || 'Aucun';
}

export function getInactiveReasonDialogTitle(reason) {
  switch (normalizeInactiveReason(reason)) {
    case 'maintenance':
      return 'Application en maintenance';
    case 'update':
      return 'Mise à jour en cours';
    case 'end_of_service':
      return 'Application retirée';
    default:
      return 'Application indisponible';
  }
}

export function getInactiveReasonDialogMessage(reason) {
  switch (normalizeInactiveReason(reason)) {
    case 'maintenance':
      return 'est actuellement en maintenance.';
    case 'update':
      return 'est en cours de mise à jour.';
    case 'end_of_service':
      return "n'est plus proposée.";
    default:
      return 'est temporairement indisponible.';
  }
}

export function getInactiveReasonDialogFallback(reason, hasEta) {
  if (hasEta) return '';
  switch (normalizeInactiveReason(reason)) {
    case 'maintenance':
      return 'Merci de votre patience.';
    case 'update':
      return 'Une nouvelle version sera disponible prochainement.';
    case 'end_of_service':
      return 'Contactez votre administrateur pour une alternative.';
    default:
      return 'Veuillez réessayer plus tard ou contacter votre administrateur.';
  }
}

export function getInactiveReasonAccentClass(reason) {
  switch (normalizeInactiveReason(reason)) {
    case 'maintenance':
      return 'from-amber-500/15 to-transparent';
    case 'update':
      return 'from-sky-500/15 to-transparent';
    case 'end_of_service':
      return 'from-violet-500/15 to-transparent';
    default:
      return 'from-[#f76f4b]/15 to-transparent';
  }
}

export function formatInactiveExpectedAvailability(app) {
  const iso = app?.inactive_expected_available_at;
  if (!iso || !String(iso).trim()) return '';
  const { date, time } = utcIsoToParisDateAndTime(iso);
  if (!date || !time) return '';
  return `${date} à ${toTimeInputValue(time)}`;
}
